"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  availableHearts: 'Available Hearts',
  availablePoints: 'Available Points',
  noProductsFound: 'No "{name}" products found',
  notEnoughHeartsCollected: 'Not enough hearts collected',
  notEnoughPointsCollected: 'Not enough points collected',
  offerEndsX: 'Offer ends {value}',
  regularPrice: 'Regular price',
  searchOffers: 'Search offer by product name or code',
  xHeartsExpireInYDays: '{value} hearts expire in {days} days',
  xPointsExpireInYDays: '{value} points expire in {days} days',
  youAddedAMaximumNumber: 'You added a maximum number'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-offers';